export enum eApplicationActions {
  CreateOrderLinkRequest = 'Application Action - Create Order Link Request',
  ReplaceOrderLinkRequest = 'Application Action - Replace Order Link Request',
  DeleteOrderLinkRequest = 'Application Action - Delete Order Link Request',

  StartPartyEdit = 'Application Action - Start Party Edit',
  StartPartyCreate = 'Application Action - Start New Party',
  StartPartyDelete = 'Application Action - Start Party Delete',
  StartPartyInviting = 'Application Action - Start Party Inviting',
  ChangePartyModalMessage = 'Application Action - Change Party Modal Message',
  ClearPartyModalMessage = 'Application Action - Clear Party Modal Message',

  FinishPartyChanges = 'Application Action - Finish Party Edit/Create/Delete',

  ChangeValues = 'Application Action - Change Values',

  SetLenderUserList = 'Application Action - Set Lender User List',
}
